import _ from 'lodash';
import swal from 'sweetalert2';

require('sweetalert2/dist/sweetalert2.css');

const VueSwal = {
  install: (vueInstance) => {
    _.set(vueInstance, 'config.globalProperties.$swal', swal);
  },
};

export default VueSwal;
